import React, { useEffect, useRef, useState } from "react";
/* Components */
import OptionCounter from "../form-elements/OptionCounter/optionCounter";
import Button from "../button/button";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { fetchChatGPT } from "../../services/chat.service";
import useSnackbarStore from "../../store/snackbarStore";
import { useMixPanel } from '../../hooks/useMixPanel';
import { useTranslation } from 'react-i18next';
import useUsageStore from '../../store/useUsageStore';
import useSessionStore from '../../store/useSessionStore';
import useGlobalStore from "../../store/useGlobalStore";
import { getUsage } from '../../services/useCaseUsage.service';
import { FormProvider, useForm } from 'react-hook-form';
import TextInput2 from '../form-elements/TexInput2/TextInput2';
import TextArea2 from '../form-elements/TextArea2/textArea2';
import { v4 as uuidv4 } from "uuid";
import { MIX_PANEL_EVENTS } from '../../utils/constans';
import useCaseStore from '../../store/useCaseStore';



const FormAssess = () => {
  const navigate = useNavigate();
  const { show } = useSnackbarStore();
  const { sendEvent } = useMixPanel();
  const { t, i18n } = useTranslation();
  // eslint-disable-next-line
  const { gptSuccess, setGPTSuccess, gptLoading, setGPTLoading } = useGlobalStore();
  const { setUsage } = useUsageStore()
  const { user } = useSessionStore()
  const methods = useForm();
  const { handleSubmit, setValue } = methods;
  const sessionIdRef = useRef(null);
  const { useCaseList, setAssesMessages, setAssesUserContext, assesForm, setAssesForm } = useCaseStore();

  const currentUseCase = useCaseList?.find(e => e.description === 'evaluacion');
  const useCaseId = currentUseCase ? currentUseCase.id : null;

  const questions = [
    { order: 1, field: "clase", question: t("formulario_evaluacion_contexto_clase"), default: null },
    { order: 2, field: "grado", question: t("formulario_evaluacion_contexto_grado"), default: null },
    { order: 3, field: "edad", question: t("formulario_evaluacion_contexto_edad"), default: "Inferir según el grado" },
    { order: 4, field: "estandar", question: t("formulario_evaluacion_contexto_estandar"), default: null },
    { order: 8, field: "consideraciones", question: t("formulario_evaluacion_contexto_consideraciones"), default: "no aplican" }
  ];

  const getUsagemutation = useMutation(getUsage, {
    onSuccess: (data) => {
      setUsage({
        total: data?.total,
        limit: data?.limit,
        percentage: data?.usagePercentage,
      });
    },
    onError: () => {},
  });

  const mutation = useMutation(fetchChatGPT, {
    onSuccess: (res) => {
      getUsagemutation.mutate(user?.email);
      sendEvent(MIX_PANEL_EVENTS.assessmentUseCaseResponse)
      setAssesMessages(res?.messages);
      setGPTLoading(false);
      setGPTSuccess(true);
      navigate(`/design-assess?sessionId=${sessionIdRef.current}`);
      
    },
    onError: (err) => {
      if(err.response.status === 403){
        navigate("/");
      } else {
        show("Ocurrio un error, vuelve a intentar", "error");
      }
      setGPTLoading(false);
      setGPTSuccess(false);
    },
  });

  const onSubmit = (formData) => {

    const prepareQuestions = questions.map((e) => ({
      ...e,
      value: formData[e.field],
    }));

    const parsedQuestions = prepareQuestions.map(
      (e) => `${e.question}: ${!e.value  && e.default ? e.default : e.value}`
    );

    if(!option1 && !option2 && !option3 ){
      setAlertOption(true)
      return
    }

    if(option1) parsedQuestions.push(`${t("formulario_evaluacion_contexto_verdadero_falso")}: ${option1}`);
    if(option2) parsedQuestions.push(`${t("formulario_evaluacion_contexto_seleccion_multiple")}: ${option2}`);
    if(option3) parsedQuestions.push(`${t("formulario_evaluacion_contexto_preguntas_abiertas")}: ${option3}`);
    console.log('option1 ', option1);


    const content = `Context: \`\`\`${parsedQuestions.join("  ")}\`\`\` `;
    console.log('content ', content);
    sessionIdRef.current = uuidv4();
    const payload = {
      messages: [{ role: "user", content }],
      type: "evaluacion",
      session_id: sessionIdRef.current,
      use_case_id: useCaseId,
      lang: i18n.language
    };
    setAssesUserContext(content);   
    setGPTLoading(true);
    sendEvent(MIX_PANEL_EVENTS.assessmentUseCaseSend);
    mutation.mutate(payload);
  };


  const increaseCounter = (option, setOption) => {
    setOption(option + 1);
  };

  const decreaseCounter = (option, setOption) => {
    if (option > 0) {
      setOption(option - 1);
    }
  };
  const [option1, setOption1] = useState(0);
  const [option2, setOption2] = useState(0);
  const [option3, setOption3] = useState(0);
  const [alertOption, setAlertOption] = useState(false);

  useEffect(() => {
    sendEvent(MIX_PANEL_EVENTS.assessmentUseCaseView);
    // eslint-disable-next-line
  },[])

  useEffect(() => {
    if (assesForm.length) {
      assesForm.forEach((element) => {
        setValue(element.field, element.value);
        if(element.field === 'option1') setOption1( element.value);
        if(element.field === 'option2') setOption2( element.value);
        if(element.field === 'option3') setOption3( element.value);
      });
    }
  }, [assesForm, setValue]);

  useEffect(() => {
    return () => {
      setAssesForm([])
      setAssesUserContext("")
      setGPTSuccess(false);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="input-row">
          <TextInput2
            label={t('formulario_evaluacion_campo_clase_materia_label')}
            labelInstruction={t('formulario_evaluacion_campo_clase_materia_instruction')}
            name="clase"
            placeHolder={t("formulario_evaluacion_campo_placeholder_clase_materia")}
            maxLength={"60"}
            required
          />
          <TextInput2
            label={t('formulario_evaluacion_campo_grado_nivel_label')}
            labelInstruction={t('formulario_evaluacion_campo_grado_nivel_instruction')}
            name="grado"
            placeHolder={t("formulario_evaluacion_campo_placeholder_grado_nivel")}
            maxLength={"20"}
            required
          />
        </div>
        <TextInput2
            label={t('formulario_evaluacion_campo_edad_label')}
            labelInstruction={t('formulario_evaluacion_campo_edad_instruction')}
            name="edad"
            placeHolder={t("formulario_evaluacion_campo_placeholder_edad")}
            maxLength={"20"}
            required
          />
        <TextArea2
          label={t('formulario_evaluacion_campo_estandar_label')}
          labelInstruction={t('formulario_evaluacion_campo_estandar_instruction')}
          name="estandar"
          placeholder={t("formulario_evaluacion_campo_placeholder_estandar")}
          maxLength={"2000"}
          required
        />
        <div className="input-text">
          <label className="input-label">{t('assessLabelQuestions')}</label>
          <label className="input-instruction">{t('assessLabelInstructionQuestions')}</label>
          <div className='input-group'>
            <div className='flex-row text-center' ><OptionCounter
              label={`${t('false')} / ${t('true')}`}
              counter={option1}
              increaseCounter={() => increaseCounter(option1, setOption1)}
              decreaseCounter={() => decreaseCounter(option1, setOption1)}
            /></div>
            <div className='flex-row text-center' ><OptionCounter
              label={t('multipleOption')}
              counter={option2}
              increaseCounter={() => increaseCounter(option2, setOption2)}
              decreaseCounter={() => decreaseCounter(option2, setOption2)}
            /></div>
            <div className='flex-row text-center' ><OptionCounter
              label={t('openQuestion')}
              counter={option3}
              increaseCounter={() => increaseCounter(option3, setOption3)}
              decreaseCounter={() => decreaseCounter(option3, setOption3)}
            /></div>
          </div>
          { alertOption && <div className='mt-2 text-white font-bold text-center'>Debe seleccionar al menos 1</div> }
        </div>
        <TextArea2
          label={t('formulario_evaluacion_campo_consideraciones_label')}
          labelInstruction={t('formulario_evaluacion_campo_consideraciones_instruction')}
          name="consideraciones"
          placeholder={t("formulario_evaluacion_campo_placeholder_consideraciones")}
          maxLength={"2000"}
        />
        <div className="form-CTA">
          <Button
            label={gptLoading ? `${t('creating')} ...` : t('createAssessButton')}
            variant="primary"
            typeB="submit"
            disabled={gptLoading}
          />
        </div>
      </form>
    </FormProvider>
    </>
  );
};

export default FormAssess;
